import { render, staticRenderFns } from "./ansLayout.vue?vue&type=template&id=c92c301e&scoped=true&"
import script from "./ansLayout.vue?vue&type=script&lang=js&"
export * from "./ansLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c301e",
  null
  
)

export default component.exports